import { Component, Input, OnInit } from '@angular/core';
import { NavItemType } from './models/nav-item-type.enum';
import { NavItemModel } from './models/nav-item.model';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
})
export class NavItemComponent implements OnInit {
  @Input() item?: NavItemModel;

  public itemType: typeof NavItemType = NavItemType;

  constructor() {}

  ngOnInit(): void {}
}
